exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.white-blue-link{color:#fff}.white-blue-link:hover{color:#4099ff}.footer-wrapper{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/footer/footer.styl
// module id = 189
// module chunks = 0